import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import CloseIcon from '@material-ui/icons/Close';
import { Button, Grid, makeStyles } from '@material-ui/core';
import Theme from '../ui/Theme';
import ErrorIcon from '../../assets/ErrorIcon';

const customStyles = {
  content: {
    height: '510px',
    width: '455px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '15px',
  },
};
const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
    color: 'red',
  },
  popSubmitBtn: {
    padding: '0 70px',
    height: '45px',
    width: '250px',
    color: 'red',
  },
  popCancelBtn: {
    padding: '0 70px',
    height: '45px',
    width: '170px',
    marginRight: '28px',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
  content: {
    paddingLeft: '16px',
    paddingRight: '16px',
  },
  scrollContent: {
    width: '100%',
    maxHeight: '250px',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  primaryText: {
    margin: '0',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '134%',
  },
  secondaryText: {
    margin: '0',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '120%',
  },
  errorIconDiv: {
    textAlign: 'center',
    marginBottom: '20px',
  },
}));

export default function AddNewJourneyErrorPopup({ close, accept, journeyList }) {
  const classes = useStyles();

  const [ruleJourneys, setRuleJourneys] = useState([]);
  const [roleJourneys, setRoleJourneys] = useState([]);

  useEffect(() => {
    const tempRule = [];
    const tempRole = [];
    journeyList.reduce((acc, val) => {
      if (val.checked) {
        acc.push(val.id);
        if (val.isOtherRule) {
          tempRule.push(val);
        }
        if (val.isRoleMapped) {
          tempRole.push(val);
        }
      }
      return acc;
    }, []);
    setRuleJourneys(tempRule);
    setRoleJourneys(tempRole);
  }, [journeyList]);

  return (
    <Modal isOpen onRequestClose={close} style={customStyles}>
      <Grid container direction="row" alignItems="center">
        <Grid item xs={11}></Grid>
        <Grid item xs={1}>
          <CloseIcon className={classes.popupCloseBtn} onClick={close} />
        </Grid>
      </Grid>
      <Grid container direction="row" alignItems="center" justifyContent="center">
        <Grid item className={classes.popupHeading}>
          Are you sure of this change?
        </Grid>
      </Grid>
      <div className={classes.errorIconDiv}>
        <ErrorIcon />
      </div>
      <Grid container direction="row" className={classes.scrollContent}>
        <Grid item xs={12} className={classes.content}>
          <Grid container direction="column">
            {ruleJourneys.length ? (
              <>
                <span className={classes.primaryText}>
                  {ruleJourneys.length} Journeys are already mapped to another rule. Assigning the present rule will
                  override all previous rule mappings.
                </span>
                <br />
                <span className={classes.secondaryText}>{ruleJourneys.map((i) => i.title).join(', ')}</span>
              </>
            ) : null}
          </Grid>
          <hr style={{ marginTop: '30px', marginBottom: '30px' }} />
          <Grid container direction="column">
            {roleJourneys.length ? (
              <>
                <span className={classes.primaryText}>
                  {roleJourneys.length} Journeys are already mapped to department roles. Adding custom rule mapping will
                  delete department role mappings.
                </span>
                <br />
                <span className={classes.secondaryText}>{roleJourneys.map((i) => i.title).join(', ')}</span>
              </>
            ) : null}
          </Grid>
        </Grid>
      </Grid>
      <Grid container justifyContent="center" alignItems="center" style={{ marginTop: '50px' }}>
        <Button variant="contained" className={classes.popCancelBtn} onClick={close}>
          Cancel
        </Button>
        <Button variant="contained" className={classes.popSubmitBtn} onClick={accept}>
          Yes, I am sure!
        </Button>
      </Grid>
    </Modal>
  );
}
